module.exports = __webpack_public_path__ + "static/UnboundWorldsApart3-5509afbe6181a341be1fdfdd83c6ee02.webp";